
// START / END SEASON of licences of a business, shared by the licence card (one licence)
// and the season screen of the business (several: one call, one invoice). The server reads
// the licences and writes their season, so they have to be saved before; done runs once
// it answered OK, for the caller to read them back.
class LicenseSeasonActions
{
    // (MIOJSLibs calls an alert action or a fetch completion only when it has a target)

    // START asks whether to invoice the first period of the licences now
    static start( vc:MUIViewController, business:BusinessLicense, licenses:License[], date:Date, done:() => void ) {
        let avc = new MUIAlertViewController();
        avc.initWithTitle(MIOLocalizeString("START_SEASON", "START SEASON"), MIOLocalizeString("INVOICE_THE_FIRST_PERIOD_NOW", "INVOICE THE FIRST PERIOD NOW?"), MUIAlertViewStyle.Default);

        avc.addAction( MUIAlertAction.alertActionWithTitle(MIOLocalizeString("START_AND_INVOICE", "START AND INVOICE"), MUIAlertActionStyle.Default, vc, function(){
            LicenseSeasonActions.callStart( vc, business, licenses, date, true, done );
        }));

        avc.addAction( MUIAlertAction.alertActionWithTitle(MIOLocalizeString("START_WITHOUT_INVOICE", "START WITHOUT INVOICE"), MUIAlertActionStyle.Default, vc, function(){
            LicenseSeasonActions.callStart( vc, business, licenses, date, false, done );
        }));

        avc.addAction( MUIAlertAction.alertActionWithTitle(MIOLocalizeString("CANCEL", "CANCEL"), MUIAlertActionStyle.Cancel, null, null));

        vc.presentViewController( avc, true );
    }

    static end( vc:MUIViewController, business:BusinessLicense, licenses:License[], date:Date, done:() => void ) {
        let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;
        ad.webService.endBusinessLicenseSeason( business, licenses, date, (data:any, error:string) => {
            if (error != null) {
                AppHelper.showErrorMessage( vc, MIOLocalizeString("ERROR", "ERROR"), error );
                return;
            }
            AppHelper.showInfoMessage( vc, MIOLocalizeString("INFO", "INFO"), MIOLocalizeString("SEASON_ENDED", "SEASON ENDED") );
            done();
        });
    }

    // The server saved the licences (season, renewal dates), their tokens and the log: read them back
    static reload( business:BusinessLicense, done:() => void ) {
        DBHelper.queryObjectsWithCompletion( "License", null, MIOPredicate.predicateWithFormat("business = " + business.identifier), ["tokens"], LicenseSeasonActions, function(){
            done();
        });
    }

    private static callStart( vc:MUIViewController, business:BusinessLicense, licenses:License[], date:Date, invoice:boolean, done:() => void ) {
        let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;
        ad.webService.startBusinessLicenseSeason( business, licenses, date, invoice, (data:any, error:string) => {
            if (error != null) {
                AppHelper.showErrorMessage( vc, MIOLocalizeString("ERROR", "ERROR"), error );
                return;
            }
            let doc = data != null ? data["documentNumber"] : null;
            AppHelper.showInfoMessage( vc, MIOLocalizeString("INFO", "INFO"), doc != null && doc.length > 0 ? MIOLocalizeString("SEASON_STARTED_INVOICE", "SEASON STARTED. INVOICE") + " " + doc : MIOLocalizeString("SEASON_STARTED", "SEASON STARTED") );
            done();
        });
    }
}
